"use strict";
var DefaultOptions_1 = require('../DefaultOptions');
var extend = require('extend');
var OptionsParser_1 = require('../OptionsParser');
var Options = (function () {
    function Options(opts) {
        this.extendDefault(OptionsParser_1.default.fromLiteral(opts));
    }
    Options.fromElement = function (el) {
        return (new Options()).extend(OptionsParser_1.default.fromElement(el));
    };
    Options.prototype.extendDefault = function (opts) {
        return extend(this, DefaultOptions_1.default, opts);
    };
    Options.prototype.extend = function (opts) {
        return extend(this, opts);
    };
    Options.prototype.containsEventTrigger = function (eventType) {
        eventType = eventType.toLowerCase();
        return this.trigger.some(function (t) { return t.eventType === eventType; });
    };
    return Options;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Options;
